"use client";

import { lazy } from "react";

import withMonarchMetadata from "@/monarch/withMonarchMetadata";

const listOfMonarchComponents = {
  navigationNavBarEditable: withMonarchMetadata(
    lazy(() => import("./Navigation | Nav Bar | Editable"))
  ),
  sectionFullImageBannerEditable: withMonarchMetadata(
    lazy(() => import("./Section | Full Image Banner | Editable"))
  ),
  sectionBentoCtaEditable: withMonarchMetadata(
    lazy(() => import("./Section | Two Fold Banner | Editable"))
  ),
  heroOverlayEditable: withMonarchMetadata(
    lazy(() => import("./Hero | Overlay | Editable"))
  ),
  heroBaseEditable: withMonarchMetadata(
    lazy(() => import("./Hero | Base | Editable"))
  ),
  heroCallHeavyEditable: withMonarchMetadata(
    lazy(() => import("./Hero | Call Heavy | Editable"))
  ),
  heroLocalResonatorEditable: withMonarchMetadata(
    lazy(() => import("./Hero | Local Resonator | Editable"))
  ),
  heroModularEditable: withMonarchMetadata(
    lazy(() => import("./Hero | Modular | Editable"))
  ),
  heroBenefitHighlightEditable: withMonarchMetadata(
    lazy(() => import("./Hero | Benefit Highlight | Editable"))
  ),
  heroTickerHighlightEditable: withMonarchMetadata(
    lazy(() => import("./Hero | Ticker Highlight | Editable"))
  ),
  sectionBentoCarouselEditable: withMonarchMetadata(
    lazy(() => import("./Section | Bento Carousel | Editable"))
  ),
  bannerMobileStickyCtaEditable: withMonarchMetadata(
    lazy(() => import("./Banner | Mobile Sticky CTA | Editable"))
  ),
  bannerStickySmallCtaEditable: withMonarchMetadata(
    lazy(() => import("./Banner | Sticky Small CTA | Editable"))
  ),
  bannerStickyOfferBannerEditable: withMonarchMetadata(
    lazy(() => import("./Banner | Sticky Offer Banner | Editable"))
  ),
  bannerCountdownBannerEditable: withMonarchMetadata(
    lazy(() => import("./Banner | Countdown Banner | Editable"))
  ),
  bannerReliabilityAwardEditable: withMonarchMetadata(
    lazy(() => import("./Banner | Reliability Award | Editable"))
  ),
  sectionBannerTopClickOrCallEditable: withMonarchMetadata(
    lazy(() => import("./Section | Banner Top Click Or Call | Editable"))
  ),
  sectionCtaBannerEditable: withMonarchMetadata(
    lazy(() => import("./Section | CTA Banner | Editable"))
  ),
  sectionUniversalOfferBannerEditable: withMonarchMetadata(
    lazy(() => import("./Section | Universal Offer Banner | Editable"))
  ),
  sectionPriceProductCardsLocalizableEditable: withMonarchMetadata(
    lazy(
      () => import("./Section | Price Product Cards (Localizable) | Editable")
    )
  ),
  sectionProductCardsLocalizableEditable: withMonarchMetadata(
    lazy(() => import("./Section | Product Cards (Localizable) | Editable"))
  ),
  sectionXmProductCardsEditable: withMonarchMetadata(
    lazy(() => import("./Section | XM Product Cards | Editable"))
  ),
  sectionXmCondensedProductCardsEditable: withMonarchMetadata(
    lazy(() => import("./Section | XM Condensed Product Cards | Editable"))
  ),
  sectionBentoTabsOrderEditable: withMonarchMetadata(
    lazy(() => import("./Section | Bento Tabs Order | Editable"))
  ),
  sectionSimplifiedBentoEditable: withMonarchMetadata(
    lazy(() => import("./Section | Simplified Bento | Editable"))
  ),
  sectionAnchorCtaEditable: withMonarchMetadata(
    lazy(() => import("./Section | Anchor CTA | Editable"))
  ),
  sectionAnimatedValuePropsEditable: withMonarchMetadata(
    lazy(() => import("./Section | Animated Value Props | Editable"))
  ),
  sectionPhoneCalloutEditable: withMonarchMetadata(
    lazy(() => import("./Section | Phone Callout | Editable"))
  ),
  sectionValuePropsEditable: withMonarchMetadata(
    lazy(() => import("./Section | Value Props | Editable"))
  ),
  sectionBenefitTilesEditable: withMonarchMetadata(
    lazy(() => import("./Section | Benefit Tiles | Editable"))
  ),
  sectionBringYourOwnDeviceEditable: withMonarchMetadata(
    lazy(() => import("./Section | Bring Your Own Device | Editable"))
  ),
  sectionCompetitorComparisonEditable: withMonarchMetadata(
    lazy(() => import("./Section | Competitor Comparison | Editable"))
  ),
  sectionSpeedProductCardsEditable: withMonarchMetadata(
    lazy(() => import("./Section | Speed Product Cards | Editable"))
  ),
  sectionXfinityProEditable: withMonarchMetadata(
    lazy(() => import("./Section | Xfinity Pro | Editable"))
  ),
  heroCompetitorEditable: withMonarchMetadata(
    lazy(() => import("./Hero | Competitor | Editable"))
  ),
  sectionWhyXfinityEditable: withMonarchMetadata(
    lazy(() => import("./Section | Why Xfinity | Editable"))
  ),
  bannerIconListBannerEditable: withMonarchMetadata(
    lazy(() => import("./Banner | Icon List Banner | Editable"))
  ),
  bannerLocalResonatorEditable: withMonarchMetadata(
    lazy(() => import("./Banner | Local Resonator | Editable"))
  ),
  sectionLocalizationBannerEditable: withMonarchMetadata(
    lazy(() => import("./Section | Localization Banner | Editable"))
  ),
  sectionLocalizationBannerRedesignEditable: withMonarchMetadata(
    lazy(() => import("./Section | Localization Banner Redesign | Editable"))
  ),
  sectionShoppingFromBannerEditable: withMonarchMetadata(
    lazy(() => import("./Section | Shopping From Banner | Editable"))
  ),
  heroLocalizationEditable: withMonarchMetadata(
    lazy(() => import("./Hero | Localization | Editable"))
  ),
  heroExistingCustomerEditable: withMonarchMetadata(
    lazy(() => import("./Hero | Existing Customer | Editable"))
  ),
  pageBackgroundColorEditable: withMonarchMetadata(
    lazy(() => import("./Page | Background Color | Editable"))
  ),
  modalTriggeredEditable: withMonarchMetadata(
    lazy(() => import("./Modal | Triggered | Editable"))
  ),
  sectionServiceBundleEditable: withMonarchMetadata(
    lazy(() => import("./Section | Service Bundle | Editable"))
  ),
  sectionBundleComparisonEditable: withMonarchMetadata(
    lazy(() => import("./Section | Bundle Comparison | Editable"))
  ),
  // Key must match the Monarch component Custom ID exactly, including the capital Q.
  sectionFaQsEditable: withMonarchMetadata(
    lazy(() => import("./Section | FAQs | Editable"))
  ),
  sectionSlimFaQsEditable: withMonarchMetadata(
    lazy(() => import("./Section | Slim FAQs | Editable"))
  ),
  sectionReliabilityInPracticeEditable: withMonarchMetadata(
    lazy(() => import("./Section | Reliability in Practice | Editable"))
  ),
  sectionAwardsShowcaseEditable: withMonarchMetadata(
    lazy(() => import("./Section | Awards Showcase | Editable"))
  ),
  sectionMobilePlansCarouselEditable: withMonarchMetadata(
    lazy(() => import("./Section | Mobile Plans Carousel | Editable"))
  ),
  sectionSimplifiedCheckoutEditable: withMonarchMetadata(
    lazy(() => import("./Section | Simplified Checkout | Editable"))
  ),
  heroSocialCarouselEditable: withMonarchMetadata(
    lazy(() => import("./Hero | Social Carousel | Editable"))
  ),
  empty: lazy(() => import("./Empty")),
};

export default listOfMonarchComponents;
